import Vue from 'vue'
import Vuex from 'vuex'
import {
    editUserInfo,
    getDictDetail,
    getMarketHighestPrice,
    getScanRecord,
    getUserInfo,
    getUserStatus,
    login
} from "@/api";
import {getMarketReturn} from "@/api/ctc";
import router from "@/router";
import {MessageBox} from 'element-ui';
import {getImpawnUserList} from "@/api/my";
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        statusBarHeight: 10,
        token: '',
        userInfo: {},
        marketAveragePrice: {},
        userStatus: 'success',
        adminKey: '',
        rePaymentAdminKey: '',
        dictData: {},
        jsQrCode: '',
        recordList: [],
		impawnUserList: [],//战车列表
    },
    getters: {
        statusBarHeight: (state) => state.statusBarHeight,
        screenHeight: (state) => {
            // console.log(state.statusBarHeight)
            if (state.statusBarHeight) {
                return window.innerHeight - state.statusBarHeight

            } else {
                return window.innerHeight
            }

        },
        token: (state) => state.token,
        userInfo: (state) => state.userInfo,
        marketReturn: (state) => state.marketAveragePrice,
        userStatus: (state) => state.userStatus,
        adminKey: (state) => state.adminKey,
        rePaymentAdminKey: (state) => state.rePaymentAdminKey,
        saiServeOfPoints: (state) => state.dictData['saiServeOfPoints'],
        saiServeOfGHS: (state) => state.dictData['saiServeOfGHS'],
        saiMagnification: (state) => state.dictData['saiMagnification'],
        dictData: (state) => state.dictData,
        jsQrCode: (state) => state.jsQrCode,
        recordList: (state) => state.recordList,
		impawnUserList: (state) => state.impawnUserList,
    },
    mutations: {
        set_statusBarHeight: (state, value) => {

            state.statusBarHeight = value
            // console.log('设置的高', value)
        },
        set_token: (state, value) => {
            // state.token = '0x77449b9a6829659e28f00c6f8c4d9d0b57ab6b7f'
            state.token = value.toLowerCase()
        },
        set_userInfo: (state, value) => {
            state.userInfo = value
        },
        set_marketAveragePrice: (state, {key, value}) => {
            state.marketAveragePrice[key] = value
        },
        set_userStatus: (state, value) => {
            state.userStatus = value
        },
        set_adminKey: (state, value) => {
            state.adminKey = value
        },
        set_rePaymentAdminKey: (state, value) => {
            // console.log('收款账号的id', value)
            state.rePaymentAdminKey = value
        },
        set_dictData: (state, {key, value}) => {
			console.log("赋值",key,value);
            state.dictData[key] = value
        },
        set_jsQrCode: (state, value) => {
            state.jsQrCode = value
        },
        set_recordList: (state, value) => {
            state.recordList = value
        },
		set_impawnUserList: (state, value) => {
		    state.impawnUserList = value
		}
    },
    actions: {
        login: ({commit, getters, dispatch}) => {
            return new Promise((resolve, reject) => {
                if (!getters.token) return

                login({
                    address: getters.token
                }).then(async (res) => {
                    // console.log('登录成功')

                    let info = await dispatch('getUserInfoVue')
                    resolve(info)
                    await dispatch('getUserStatusMethod')
                    await dispatch('getAdminKey')
                    await dispatch('getRecordList')
					await dispatch('getImpawnUserList')

                }).catch(async (err) => {
                    console.log('登录失败', err)
                    //
                    // await dispatch('getUserInfoVue')
                    // await dispatch('getUserStatusMethod')
                    // await dispatch('getAdminKey')
                    reject('登录失败')
                })
            })
        },
        getUserInfoVue: ({commit, getters}, type = true) => {
            if (!getters.token) return

            if (type) {
                return new Promise(resolve => {
                    getUserInfo(getters.token).then(res => {
                        // console.log('获取用户信息', res)
                        commit('set_userInfo', res.data)
                        resolve(res.data)
                    })
                })
            } else {
                if (Object.keys(getters.userInfo).length == 0) {
                    return new Promise(resolve => {
                        getUserInfo(getters.token).then(res => {
                            // console.log('获取用户信息', res)
                            commit('set_userInfo', res.data)
                            resolve(res.data)
                        })
                    })
                } else {
                    return new Promise(resolve => {
                        resolve(getters.userInfo)
                    })
                }
            }


        },
        marketAveragePrice: ({commit}) => {
            getMarketReturn({type: 'USDE'}).then(res => {
                // console.log('获取市场均价', res)
                commit('set_marketAveragePrice', {key: 'USDE', value: res.data})
            })
            getMarketReturn({type: 'GHS'}).then(res => {
                commit('set_marketAveragePrice', {key: 'GHS', value: res.data})
            })
        },
        getUserStatusMethod: ({state, commit}) => {
            return new Promise((resolve, reject) => {
                getUserStatus(state.token).then(res => {
                    // console.log('获取用户状态', res)
                    if (res.msg == '异常') {
                        setTimeout(() => {
                            router.push({name: 'CTC'})

                        }, 300)
                        resolve('error')
                        commit('set_userStatus', 'error')
                    } else {
                        resolve('success')
                        commit('set_userStatus', 'success')

                    }
                })
            })
        },
        getAdminKey: ({commit}) => {
			console.log('执行getAdminKey')
            getDictDetail(12).then(res => {
                // console.log(res)
                // commit('set_adminKey', "0x44360800ca20ec6371344a9994526585079523e8")
                commit('set_adminKey', res.data.value)
            })
            getDictDetail(36).then(res => {
                // console.log(res)

                commit('set_rePaymentAdminKey', res.data.value)
            })
            //获取字典参数
            getDictDetail(5).then(res => {
                commit('set_dictData', {key: 'saiServeOfPoints', value: res.data.value})
            })
            //GHS算力手续费

            getDictDetail(6).then(res => {
                commit('set_dictData', {key: 'saiServeOfGHS', value: res.data.value})
            })
            //usde交易手续费币种
            getDictDetail(19).then(res => {
                // console.log('usde交易币种', res)
                commit('set_dictData', {key: 'usdeServeType', value: res.data.value})
            })
            //ghs交易手续费币种
            getDictDetail(18).then(res => {
                // console.log('ghs交易币种', res)

                commit('set_dictData', {key: 'ghsServeType', value: res.data.value})
            })
            //usde交易手续费
            getDictDetail(16).then(res => {
                // console.log('usde交易币种', res)
                commit('set_dictData', {key: 'usdeServeComm', value: res.data.value})
            })
            //ghs交易手续费
            getDictDetail(17).then(res => {

                commit('set_dictData', {key: 'ghsServeComm', value: res.data.value})
            })
            //usde初始定价
            getDictDetail(15).then(res => {

                commit('set_dictData', {key: 'usdeStartTotal', value: res.data.value})
            })
            //ghs初始定价
            getDictDetail(14).then(res => {

                commit('set_dictData', {key: 'ghsStartTotal', value: res.data.value})
            })
			// 服务商地址
			getDictDetail(101).then(res => {
				console.log(res.data.value,'字典101--------')
			    commit('set_dictData', {key: 'serviceProvider', value: res.data.value})
			})
			//ghs闪兑价格
			getDictDetail(102).then(res => {
			
			    commit('set_dictData', {key: 'ghsProviderPrice', value: res.data.value})
			})
			//USDE闪兑价格
			getDictDetail(103).then(res => {
				console.log(res,'字典103--------')
			    commit('set_dictData', {key: 'usdeProviderPrice', value: res.data.value})
			})
            //USDE转赠手续费
            getDictDetail(26).then(res => {
                commit('set_dictData', {key: 'usdeGiftServe', value: res.data.value})
            })
            //USDE转赠爱心捐赠
            getDictDetail(38).then(res => {
                commit('set_dictData', {key: 'usdeGiftServeLove', value: res.data.value})
            })
            //GHS转赠爱心捐赠
            getDictDetail(39).then(res => {
                commit('set_dictData', {key: 'ghsGiftServeLove', value: res.data.value})
            })
            //算力消耗比例
            getDictDetail(27).then(res => {
                commit('set_dictData', {key: 'SAIConsume', value: res.data.value})
            })
            //USDE算力手续费
            getDictDetail(32).then(res => {
                commit('set_dictData', {key: 'saiServeOfUSDE', value: res.data.value})
            })
            //钱包体现手续费
            getDictDetail(7).then(res => {
                commit('set_dictData', {key: 'Withdrawal', value: res.data.value})
            })
            //1算力需要usde
            getDictDetail(40).then(res => {
                commit('set_dictData', {key: 'oneSaiToUSDE', value: res.data.value})
            })
            //1算力需要ghs
            getDictDetail(41).then(res => {
                commit('set_dictData', {key: 'oneSaiToGHS', value: res.data.value})
            })
            //1算力需要积分
            getDictDetail(42).then(res => {
                commit('set_dictData', {key: 'oneSaiToPoint', value: res.data.value})
            })
            //用户充值收款账号
            getDictDetail(46).then(res => {
                commit('set_dictData', {key: 'accountNumber', value: res.data.value})
            })
            //购买算力限制USDE
            getDictDetail(48).then(res => {
                commit('set_dictData', {key: 'saiXusde', value: res.data.value})
            })
            //获取币种市场最高价
            getMarketHighestPrice().then(res => {
                console.log("获取币种市场最高价", res)
                commit('set_dictData', {key: 'ghsMarkHighPrice', value: res.data.ghs})
                commit('set_dictData', {key: 'usdeMarkHighPrice', value: res.data.usde})
            })
			
			// 质押基础数量USDE
			getDictDetail(64).then(res=>{
				console.log('usde质押',res)
				commit('set_dictData', {key: 'stakingUsde', value: res.data.value})
			})
			
			// 质押基础数量GHS
			getDictDetail(59).then(res=>{
				console.log('chs质押',res)
				commit('set_dictData', {key: 'stakingGhs', value: res.data.value})
			})
			// 网页地址
			getDictDetail(87).then(res=>{
				console.log('浏览器地址',res)
				commit('set_dictData', {key: 'baseUrl', value: res.data.value})
			})


        },
        getDict: ({state}, key) => {
            return new Promise((resolve, reject) => {
                let value = state.dictData[key]

                const numberValue = Number(value)
                if (isNaN(numberValue)||(key=="serviceProvider")) {
                    resolve(value)

                } else {
                    resolve(numberValue)

                }
            })
        },
        getImpawnUserDetailStore: ({state}, key) => {
            return new Promise((resolve, reject) => {
				let objList=state.impawnUserList.filter(ele=>ele.id==key)
 
                if (objList.length==1) {
                    resolve({
						data:objList[0]
					})

                } else {
                    resolve()

                }
            })
        },
        getRecordList: ({state, commit}) => {
            let obj = {
                address: state.token,
                status: 0
            }
            getScanRecord(obj).then(res => {
                console.log('待查询记录', res)
                commit('set_recordList', res.rows)
            })
        },
		getImpawnUserList: ({state, commit}) => {
		
		    let obj = {
		        address: state.token
		    }
		    getImpawnUserList(obj).then(res => {
		        console.log('战车列表', res)
		        commit('set_impawnUserList', res.rows)
		    })
		}
    },
    modules: {}
})
